<template>
  <div>
home
<!-- <router-link></router-link> -->
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {

    };
  },
  created() {},
  mounted() {},
  methods: {

  },
  computed: {},
  watch: {},
};
</script>

<style scoped>

</style>
